// extracted by mini-css-extract-plugin
export var compactFilters = "_bz-4";
export var detailImage = "_bz-1";
export var dropdownContainer = "_bz-2";
export var imageContainer = "_bz-0";
export var selectedCard = "_bz-3";